import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { Grid } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { formatPhoneNumberIntl } from "react-phone-number-input";

const { useBreakpoint } = Grid;

export function HomeContact({ connect_with_us = {} }) {
	const screens = useBreakpoint();
	const [ref] = useTrackVisibility();
	return (
		<HomeContactContainer ref={ref}>
			<Background>
				<RAImage url={PATH_PUBLIC_IMAGES.home_contact_bg} width="100%" height="100%" borderRadius="20px" />
			</Background>
			<WrapperContent>
				<RATypography variant={screens?.md ? "h2" : "h4"} color="#fff">
					{connect_with_us?.title || ""}
				</RATypography>
				<RATypography variant="body3" color="#fff" whiteSpace="pre-wrap" align="center" top="12px">
					{connect_with_us?.sub_title || ""}
				</RATypography>
				<WrapperQuote>
					<a href={`tel:${connect_with_us?.contact_info}`}>
						<ContactButton>
							<img src="/images/homepage/phone_icon.png" style={{ width: 16 }} />
							<PhoneNumber>{formatPhoneNumberIntl(connect_with_us?.contact_info || "")}</PhoneNumber>
						</ContactButton>
					</a>
				</WrapperQuote>
			</WrapperContent>
		</HomeContactContainer>
	);
}

const ContactButton = styled.button`
	border-radius: 40px;
	border: 0.5px solid #fff;
	display: flex;
	padding: 12px 30px;
	align-items: center;
	gap: 12px;
	background: transparent;
	cursor: pointer;
`;
const PhoneNumber = styled.div`
	color: #fff;
	font-feature-settings:
		"clig" off,
		"liga" off;
	font-family: "DM Sans";
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: 2px;
`;
const HomeContactContainer = styled.div`
	width: 100%;
	position: relative;
`;
const Background = styled.div`
	width: 100%;
	height: 377px;
	@media (max-width: 767px) {
		height: 300px;
	}
	@media (max-width: 575px) {
		height: 220px;
	}
`;
const WrapperContent = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	padding: 0 30px;
`;
const WrapperQuote = styled.div`
	padding-top: 30px;
	@media (max-width: 575px) {
		padding-top: 16px;
	}
`;
